import { ApiEmailChecker } from 'ApiRest/Api/User/EmailChecker'

export default {
  async checkEmailExistence(context, params) {
    const { data } = await ApiEmailChecker.get(params)

    return data.emailExist
  },
}
